import "core-js/modules/es.array.push.js";
import { captureException } from "@sentry/vue";
export default {
  name: "AppHeader",
  data() {
    return {
      navigationDrawerOpen: false
    };
  },
  methods: {
    logout() {
      this.$http.post('signOut').then(() => {
        this.$store.dispatch('authLogout').then(() => {
          this.$router.push({
            path: '/login'
          });
        }).catch(error => captureException(error));
      });
    }
  },
  mounted() {
    if (this.$store.getters.isAdviserSignedIn) {
      this.$store.dispatch('getSchool').then(response => {
        if (!response.data.status) {
          console.log(Error[response.data.errorCode]);
        }
      }).catch(error => {
        captureException(error);
        this.logout();
      });
    }
  },
  computed: {
    isAdviserSignedIn() {
      return this.$store.getters.isAdviserSignedIn;
    },
    isAdviserActive() {
      return this.$store.getters.isAdviserActive;
    },
    isSchoolInfoLoaded() {
      return this.$store.getters.isSchoolInfoLoaded;
    }
  }
};